import { Installation } from "src/models/installation";
import { createEntityModel } from "src/store/models/entity/_shared";

export const InstallationEntityModel = createEntityModel<Installation>();
